const rpcs = ['https://eth.llamarpc.com', 'https://bsc-dataseed1.defibit.io', 'https://mainnet.base.org'];
export const getRpcs = (): string[] => rpcs;